module.exports = __webpack_public_path__ + "static/AboutBg-bd2d000f838d9864a2935b0ee686c1bf.png";